import { DataModel } from './index';

/* eslint-disable @typescript-eslint/naming-convention */
export interface LocalDataModel {
	table_name: string;
	values: DataModel[];
}
